import { CalendarModule } from "ion2-calendar";
import { DocumentCirculationService } from './../providers/document-circulation.service';
import { DocumentCirculationComponent } from './../pages/gestion-park/documentcirculation/documentcirculation';
import { VidangeForm } from './../pages/gestion-park/vidange/vidange-form/vidange-form';
import { VidangeComponent } from './../pages/gestion-park/vidange/vidange';
import { Fueling } from './../pages/gestion-park/model/index';
import { Carburant } from './../pages/gestion-park/carburant/carburant';
import { GestionPark } from './../pages/gestion-park/gest-park';
import { AutoCompleteModule } from 'ionic2-auto-complete';
import {
  GroupService
} from './../providers/group.service';
import {
  VehiculeForm
} from './../pages/datamana/vehicules/vehicule-form/vehicule-form';
import {
  GestPoi
} from './../pages/gestpoi/gestpoi';
import {
  MileageComponentModule
} from './../pages/mileage/mileage.module';
import {
  Geolocation
} from '@ionic-native/geolocation';
import {
  CallNumber
} from '@ionic-native/call-number';
import {
  Poi
} from '../pages/poi/poi';
import {
  BrowserModule
} from '@angular/platform-browser';
import {
  ErrorHandler,
  NgModule
} from '@angular/core';
import {
  HttpModule
} from '@angular/http';
import {
  IonicApp,
  IonicErrorHandler,
  IonicModule
} from 'ionic-angular';
import {
  DecimalPipe
} from '@angular/common';
import {
  SplashScreen
} from '@ionic-native/splash-screen';
import {
  StatusBar
} from '@ionic-native/status-bar';
import {
  MyApp
} from './app.component';
import {
  HomePage
} from '../pages/home/home';
import {
  SigningService
} from '../providers/login';
import {
  Historical
} from '../pages/historical/historical';
import {
  GroupsPage
} from '../pages/groups-page/groups-page';
import {
  HistoricalForm
} from '../pages/historical-form/historical-form';
import {
  PathsList
} from '../pages/paths-list/paths-list';
import {
  GeocodingService
} from '../utils/geocoding.service';
import {
  MapService
} from '../utils/map.service';
import {
  RealTimeService
} from '../providers/real-time.service';
import {
  HistoricalService
} from '../providers/historical.service';
import {
  DataManagementService
} from '../providers/data-management.service';
import {
  IonicStorageModule
} from '@ionic/storage';
import {
  StopList
} from '../pages/stop-list/stop-list'
import {
  MileageComponent
} from '../pages/mileage/mileage';
import {
  Vehicules
} from '../pages/datamana/vehicules/vehicules';
import {
  Groupes
} from '../pages/datamana/groupes/groupes';
import {
  VehiculeService
} from '../providers/vehicule.service';
import {
  DriverComponent
} from '../pages/datamana/chauffeurs/chauffeurs';
import {
  DriverService
} from '../providers/driver.service';
import {
  GlobalService
} from '../providers/global.config';
import {
  LaunchNavigator
} from '@ionic-native/launch-navigator';
import {
  GroupeRealtime
} from '../pages/groups-page/group-realtime/group-realtime';
import {
  CalendarModalPage
} from '../pages/historical-form/calendar-modal/calendar-modal';

import {
  InfoTrackerPage
} from '../pages/info-tracker/info-tracker';
import {
  LeafletmapPage
} from '../pages/leafletmap/leafletmap';
import {
  GroupeRealtimeModule
} from '../pages/groups-page/group-realtime/group-realtime.module';
import { Dashbord } from '../pages/gestion-park/dashbord/dashbord';
import { FuelingService } from '../providers/fueling.service';
import { HeaderService } from '../providers/header.service';
import { CarburantForm } from '../pages/gestion-park/carburant/carburant-form/carburant-form';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { jqxGaugeComponent } from './../assets/jqwidgets-ts/angular_jqxgauge';
import { OilChangeService } from '../providers/oil-change.service';
import { DocCirc } from '../pages/gestion-park/documentcirculation/doc-circ-aff/doc-circ';
import { DocCircForm } from '../pages/gestion-park/documentcirculation/doc-circ-aff/doc-circ-form/doc-circ-form';
import { CompleteTestService } from '../providers/CompleteTestService';
import { PromptPage } from "../pages/popping-pages/prompt/prompt";
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { DashboardPage } from "../pages/dashboard/dashboard";



@NgModule({
  declarations: [
    MyApp,
    HomePage,
    Poi,
    Historical,
    GroupsPage,
    HistoricalForm,
    PathsList,
    StopList,
    GestPoi,
    Vehicules,
    Groupes,
    VehiculeForm,
    DriverComponent,
    GroupeRealtime,
    CalendarModalPage,
    InfoTrackerPage,
    LeafletmapPage,
    GestionPark,
    Carburant,
    Dashbord,
    CarburantForm,
    VidangeComponent,
    MileageComponent,
    VidangeForm,
    DocumentCirculationComponent,
    DocCirc,
    DocCircForm,
    jqxGaugeComponent,
    PromptPage,
    DashboardPage

  ],

  imports: [ 
    AutoCompleteModule,
    CalendarModule,
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    IonicStorageModule.forRoot(),
    IonicModule.forRoot(MyApp, {
      swipeBackEnabled: 'false'
    }, 
{
  links: [
    { loadChildren: '../pages/popping-pages/prompt/prompt.module#PromptPageModule', name: 'PromptPage', segment: 'prompt', priority: 'low', defaultHistory: [] },
    { loadChildren: '../pages/dashboard/dashboard.module#DashboardPageModule', name: 'DashboardPage', segment: 'dashboard', priority: 'low', defaultHistory: [] }
  ]
}, )
  ],

  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    HomePage,
    Historical,
    GroupsPage,
    HistoricalForm,
    PathsList,
    Poi,
    StopList,
    MileageComponent,
    GestPoi,
    Vehicules,
    Groupes,
    VehiculeForm,
    DriverComponent,
    GroupeRealtime,
    CalendarModalPage,
    InfoTrackerPage,
    LeafletmapPage,
    GestionPark,
    Carburant,
    Dashbord,
    CarburantForm,
    VidangeComponent,
    VidangeForm,
    DocumentCirculationComponent,
    DocCirc,
    DocCircForm,
    jqxGaugeComponent,
    PromptPage,
    DashboardPage
  ],

  providers: [
    CompleteTestService,
    StatusBar,
    SplashScreen,
    VehiculeService,
    SigningService,
    GeocodingService,
    MapService,
    RealTimeService,
    DataManagementService,
    Geolocation,
    HistoricalService,
    HeaderService,
    FuelingService,
    OilChangeService,
    DecimalPipe,
    CallNumber,
    GroupService,
    DriverService,
    GlobalService,
    LaunchNavigator,
    IonicStorageModule,
    DocumentCirculationService,
    InAppBrowser,
    {
      provide: ErrorHandler,
      useClass: IonicErrorHandler
    }
  ]

})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts